import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StandortleiterApp from './standortleiter/App';
import Form2App from './form2/App';

const App: React.FC = () => {
    return (
        <Router>
            <Routes>
                <Route path="/standortleiter" element={<StandortleiterApp />} />
                <Route path="/forms/registration/token/:token" element={<Form2App />} />
                <Route path="/forms/registration" element={<Form2App apiEndpoint="/api/forms/registration" />} />
            </Routes>
        </Router>
    );
};

export default App;
